import React from 'react';

const ArrowHalfIcon = ({ color = '#000', ...props }) => (
	<svg width="36" height="36" viewBox="0 0 36 36" {...props}>
		<g fill="none" fillRule="evenodd">
			<path d="M0 0h36v36H0z" />
			<path
				d="M13.2 30.27a26.16 26.16 0 0 1 12.57-12.465A26.22 26.22 0 0 1 13.2 5.34l-2.04.93a27.69 27.69 0 0 0 11.355 11.535 19.02 19.02 0 0 0-2.55 1.5 28.5 28.5 0 0 0-8.805 10.02l2.04.945z"
				fill={color}
				fillRule="nonzero"
			/>
		</g>
	</svg>
);

export default ArrowHalfIcon;
